import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';

export const ROOM_CREATE_INIT = createAction('ROOM_CREATE_INIT');
export const ROOM_CREATE_SUCCESS = createAction('ROOM_CREATE_SUCCESS');
export const ROOM_CREATE_FAIL = createAction('ROOM_CREATE_FAIL');

export const ROOM_FETCH_INIT = createAction('ROOM_FETCH_INIT');
export const ROOM_FETCH_SUCCESS = createAction('ROOM_FETCH_SUCCESS');
export const ROOM_FETCH_FAIL = createAction('ROOM_FETCH_FAIL');

export const ROOM_FETCH_BY_ID_INIT = createAction('ROOM_FETCH_BY_ID_INIT');
export const ROOM_FETCH_BY_ID_SUCCESS = createAction('ROOM_FETCH_BY_ID_SUCCESS');
export const ROOM_FETCH_BY_ID_FAIL = createAction('ROOM_FETCH_BY_ID_FAIL');

export const ROOM_UPDATE_INIT = createAction('ROOM_UPDATE_INIT');
export const ROOM_UPDATE_SUCCESS = createAction('ROOM_UPDATE_SUCCESS');
export const ROOM_UPDATE_FAIL = createAction('ROOM_UPDATE_FAIL');

export const ROOM_DELETE_INIT = createAction('ROOM_DELETE_INIT');
export const ROOM_DELETE_SUCCESS = createAction('ROOM_DELETE_SUCCESS');
export const ROOM_DELETE_FAIL = createAction('ROOM_DELETE_FAIL');

export const createRoom = ({
  name,
  siteId,
  capacity,
  poiIds,
  roomImage
}) => {
  return async (dispatch) => {
    dispatch(ROOM_CREATE_INIT());

    const formData = new FormData();
    formData.set('name', name);
    formData.set('siteId', siteId);
    if(capacity)formData.set('capacity', capacity);
    if (poiIds && poiIds.length > 0) {
      formData.set('poiIds', JSON.stringify(poiIds));
    }

    if (roomImage && roomImage.file) {
      formData.append('file', roomImage.file);
    }

    try {
      const response = await Axios.post(`${url}/room`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });

      toastr.success('', 'Room created successfully!');
      return dispatch(ROOM_CREATE_SUCCESS({ room: response.data.data }));
    } catch (error) {
      let errorMessage = 'Failed to create room';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      toastr.error('', errorMessage);
      return dispatch(ROOM_CREATE_FAIL({ error: errorMessage }));
    }
  };
};

export const fetchRooms = ({ siteId, search, roomId }) => {
  return async (dispatch) => {
    dispatch(ROOM_FETCH_INIT());

    const requestData = { siteId };
    if (search) {
      requestData.search = search;
    }
    if (roomId) {
      requestData.roomId = roomId;
    }

    try {
      const response = await Axios.get(`${url}/room/`, {
        params: requestData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'application/json',
        },
      });

      return dispatch(ROOM_FETCH_SUCCESS({ rooms: response.data.data }));
    } catch (error) {
      let errorMessage = 'Failed to fetch rooms';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      toastr.error('', errorMessage);
      return dispatch(ROOM_FETCH_FAIL({ error: errorMessage }));
    }
  };
};

export const fetchRoomById = (roomId) => {
  return async (dispatch) => {
    dispatch(ROOM_FETCH_BY_ID_INIT());

    try {
      const response = await Axios.get(`${url}/room/${roomId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      return dispatch(ROOM_FETCH_BY_ID_SUCCESS({ room: response.data.data }));
    } catch (error) {
      let errorMessage = 'Failed to fetch room';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      toastr.error('', errorMessage);
      return dispatch(ROOM_FETCH_BY_ID_FAIL({ error: errorMessage }));
    }
  };
};

export const updateRoom = ({
  roomId,
  name,
  siteId,
  capacity,
  poiIds,
  roomImage,
  availability
}) => {
  return async (dispatch) => {
    dispatch(ROOM_UPDATE_INIT());

    const formData = new FormData();
    formData.set('name', name);
    formData.set('siteId', siteId);
    formData.set('capacity', capacity);

    if (availability !== undefined) {
      formData.set('availability', availability);
    }

    if (poiIds && poiIds.length > 0) {
      formData.set('poiIds', JSON.stringify(poiIds));
    }

    if (roomImage && roomImage.file) {
      formData.append('file', roomImage.file);
    }

    try {
      const response = await Axios.put(`${url}/room/${roomId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });

      toastr.success('', 'Room updated successfully!');
      return dispatch(ROOM_UPDATE_SUCCESS({ room: response.data.data }));
    } catch (error) {
      let errorMessage = 'Failed to update room';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      toastr.error('', errorMessage);
      return dispatch(ROOM_UPDATE_FAIL({ error: errorMessage }));
    }
  };
};

export const deleteRoom = (roomId) => {
  return async (dispatch) => {
    dispatch(ROOM_DELETE_INIT());

    try {
      await Axios.delete(`${url}/room/${roomId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      toastr.success('', 'Room deleted successfully!');
      return dispatch(ROOM_DELETE_SUCCESS({ roomId }));
    } catch (error) {
      let errorMessage = 'Failed to delete room';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      toastr.error('', errorMessage);
      return dispatch(ROOM_DELETE_FAIL({ error: errorMessage }));
    }
  };
};
